<template>
    <nav class="panel">
        <div class="panel-entered">
          <div
              class="panel-heading"
              :class="{'is-collapsible' : collapsible}"
              @click="toggle">
            <span v-if="header" v-html="header"/>
            <slot v-else name="header"/>
            <o-icon
                class="is-pulled-right"
                v-if="collapsible"
                both
                :icon="isOpen ? 'menu-up' : 'menu-down'"
                :icon-pack="iconPack" />
          </div>
          <transition :name="animation">
            <div
                class="panel-content"
                :class="{'panel-block' : !hasCustomTemplate}"
                v-show="isOpen">
              <div v-if="content" v-html="content"/>
              <slot v-else/>
            </div>
          </transition>
        </div>
    </nav>
</template>

<script>
    import BaseElementMixin from './BaseElementMixin'

    export default {
        name: 'BPanel',
        components: {
        },
        mixins: [BaseElementMixin],
        props: {
            collapsible: {
                type: Boolean,
                default: false
            },
            open: {
                type: Boolean,
                default: true
            },
            hasCustomTemplate: {
                type: Boolean,
                default: false
            },
            header: String,
            content: String,
            animation: {
                type: String,
                default: 'fade'
            }
        },
        data() {
            return {
                isOpen: this.open
            }
        },
        watch: {
            open(value) {
                this.isOpen = value
            }
        },
        methods: {
            /**
             * Toggle the Panel and emit events if collapsible.
             */
            toggle() {
                if (!this.collapsible) return

                this.isOpen = !this.isOpen
                // this.$parent.$emit('update:active', this.isOpen)

                if (this.isOpen) {
                  $(".panel-content").show()
                } else {
                  $(".panel-content").hide()
                }
            }
        }
    }
</script>